// extracted by mini-css-extract-plugin
module.exports = {"spin":"_1ZO73xakzN","body":"_3SLqDYXnLA","aside":"_3QHN0kKsCP","main":"YplorogA5g"};